import { useEffect, useState, ChangeEvent } from 'react';
import { Alert, Box, Grid, Icon, IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { VTextFieldCpfCnpj, cpfcnpjValidator } from '../../../shared/forms';
import { VForm, useVForm, IVFormErrors, VTextField } from '../../../shared/forms';
import { FerramentasDeDetalhe } from '../../../shared/components';
import { LayoutBaseDePagina } from '../../../shared/layouts';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { DialogItens } from './dialogitens';
import { ClientesService } from '../../../shared/services/api/cadastros/ClientesService';

interface IitensFabricaDialog {
  idclifab: string;
  nome: string;
  percentual: number;
}
interface IItensids {
  idclifab: string;
}
interface IFormData {
  nome: string;
  cpf: string;
  fantasia: string;
  rg: string;
  telefone: string;
  celular: string;
  endereco: string;
  numero: string;
  bairro: string;
  cep: string;
  email: string;
  municipio: string;
}

const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'idoperacao' | 'clientes'>> = yup.object().shape({

  nome: yup.string().required().min(3).max(100),
  cpf: yup.string().required().min(11).max(14).test('cpf', 'CPF / CNPJ inválido', cpfcnpjValidator),
  fantasia: yup.string().optional().default(''),
  rg: yup.string().optional().default(''),
  telefone: yup.string().optional().default(''),
  celular: yup.string().optional().default(''),
  endereco: yup.string().optional().default(''),
  numero: yup.string().optional().default(''),
  bairro: yup.string().optional().default(''),
  cep: yup.string().optional().default(''),
  email: yup.string().email().default(''),
  municipio: yup.string().optional().default(''),
});

export const DetalheDeClientes: React.FC = () => {
  const { id = 'novo' } = useParams<'id'>();
  const navigate = useNavigate();
  const [rows, setRows] = useState<IitensFabricaDialog[]>([]);
  const [dadositens, setDadositens] = useState<IitensFabricaDialog>();
  const [nomeDaFabricaSelecionada, setNomeDaFabricaSelecionada] = useState<string>('');
  const [PercentualDaFabricaSelecionada, setPercentualDaFabricaSelecionada] = useState<number>(0);
  const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
  const [msg, setMsg] = useState('');
  const [openalert, setOpenAlert] = useState(false);
  const [edit, setEdit] = useState(false);
  const [iditens, setIditens] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [descricao, setDescricao] = useState<string>('');

  const handleClose = () => {
    setOpen(false);
  };
  type RowsType = IitensFabricaDialog[];
  const handleCloseAlert = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };
  const handleItens = (dados: IitensFabricaDialog) => {
    const index = rows.findIndex((listItem) => listItem.idclifab === dados.idclifab);

    let updatedList: RowsType;

    if (index !== -1) {
      updatedList = [...rows];
      updatedList[index] = dados;
    } else {
      updatedList = [...rows, dados];
    }
    setRows(updatedList);

    if (updatedList.length != 0) {
      setEdit(true);
    } else {
      setEdit(false);
    }
  };
  const handleBuscarDados = (id: string) => {
    const foundItem = rows.find((listItem) => listItem.idclifab === id);
    if (foundItem) {
      setDadositens(foundItem);
      setNomeDaFabricaSelecionada(foundItem.nome);
      setPercentualDaFabricaSelecionada(foundItem.percentual);
      setOpen(true); 
    }
  };
  useEffect(() => {
    if (id !== 'novo') {
      setIsLoading(true);
      ClientesService.getById(id)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            setMsg(result.message);
            setOpenAlert(true);
            navigate('/clientes');
          } else {
            formRef.current?.setData(result);
            setDescricao(result.nome);
            const fabricasNormalizadas = result.fabricas.map(fabrica => ({
              ...fabrica,
              percentual: fabrica.percentual || 0
            }));
            setRows(fabricasNormalizadas);
          }
        });
    } else {
      formRef.current?.setData({
        idparceiro: '',
        idplanoconta: '',
        idoperacoes: '',
        dataemissao: '',
        numeronota: '',
        numerodoc: '',
        subtotal: '',
        desconto: '',
        outrasdespesas: '',
        totalnota: '',
        acrescimo: '',
        obs: '',
      });
      setRows([]);
    }
  }, [id]);
  const handleSave = (dados: IFormData) => {
    formValidationSchema
      .validate(dados, { abortEarly: false })
      .then((dadosValidados) => {

        setIsLoading(true);
        if (id === 'novo') {
          ClientesService
            .create(dadosValidados)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                setMsg(result.message);
                setOpenAlert(true);
              } else {
                if (isSaveAndClose()) {
                  navigate('/clientes');
                } else {
                  navigate(`/clientes/${result}`);
                }
              }
            });
        } else {
          ClientesService
            .updateById(id, dadosValidados)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                setMsg(result.message);
                setOpenAlert(true);
              } else {
                if (isSaveAndClose()) {
                  navigate('/clientes');
                }
              }
            });
        }
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;

          validationErrors[error.path] = error.message;
        });

        formRef.current?.setErrors(validationErrors);
      });
  };
  // const handleCPFCNPJChange = async (event: ChangeEvent<HTMLInputElement>) => {

  //   const fieldName = 'cpf';
  //   const enteredValue = event.target.value.replace(/[^\d]/g, ''); // Remove todos os caracteres não numéricos

  //   try {
  //     await formValidationSchema.validateAt(fieldName, { [fieldName]: enteredValue });  
  //     if ((enteredValue.length === 11 || enteredValue.length === 14) && enteredValue) { // Verifica se o valor tem entre 9 e 14 dígitos
  //       setIsLoading(true);
  //       try {

  //         const response = await CpfService.getAll(enteredValue); // Envia o valor para a API

  //         setIsLoading(false);

  //         if (typeof response !== 'string') {
  //           const isErrorResponse = 'message' in response && 'name' in response;

  //           if (isErrorResponse) {
  //             console.error('Erro ao consultar a API:', response);
  //             return;
  //           }
  //           throw new Error('Resposta inesperada da API');
  //         }

  //         const data: string = response;

  //         if (data !== 'false') {
  //           navigate(`/parceiros/detalhes/${data}`);
  //         } else if (enteredValue.length === 14 && data === 'false') { // Verifica se é CNPJ e o retorno foi 'false'
  //           setIsLoading(true);

  //           const cnpjData = await CnpjService.getAll(enteredValue);

  //           if (Array.isArray(cnpjData) && cnpjData.length > 0) {
  //             const dataAtIndex0 = cnpjData[0]; // Acessa os dados na posição 0 do array
  //             const hasUndefinedFields = Object.values(dataAtIndex0).some(value => value === undefined);

  //             if (hasUndefinedFields) {
  //               alert('CNPJ não encontrado na SEFAZ');
  //             } else {
  //               formRef.current?.setData({ ...formRef.current?.getData(), ...dataAtIndex0 });
  //             }
  //           } else {
  //             alert('CNPJ não encontrado na SEFAZ');
  //           }
  //         }
  //       } catch (error) {
  //         // console.error('Erro ao consultar a API:', error);
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     }} catch (error) {
  //     setIsLoading(false);
  //   }
  // };

  const handleDelete = (id: string) => {
    if (confirm('Realmente deseja apagar?')) {
      ClientesService

        .deleteById(id)
        .then(result => {
          if (result instanceof Error) {
            setMsg(result.message);
            setOpenAlert(true);
          } else {
            setMsg('Registro apagado com sucesso!');
            setOpenAlert(true);
            navigate('/clientes');
          }
        });
    }
  };

  return (
    <LayoutBaseDePagina
      titulo={id === 'novo' ? 'Novo Cliente' : descricao}
      barraDeFerramentas={
        <FerramentasDeDetalhe
          textoBotaoNovo='Novo'
          mostrarBotaoSalvarEFechar
          mostrarBotaoSalvarCarregando={isLoading}
          mostrarBotaoSalvarEFecharCarregando={isLoading}
          mostrarBotaoNovo={id !== 'novo'}
          mostrarBotaoApagar={id !== 'novo'}
          mostrarBotaoImpressao={false}
          mostrarBotaoApagarCarregando={isLoading}
          mostrarBotaoImpressaoCarregando={isLoading}
          aoClicarEmSalvar={save}
          aoClicarEmSalvarEFechar={saveAndClose}
          aoClicarEmVoltar={() => navigate('/clientes')}
          mostrarBotaoVoltarCarregando={isLoading}
          aoClicarEmApagar={() => handleDelete(id)}
          aoClicarEmNovo={() => navigate('/clientes/novo')}
          mostrarBotaoNovoCarregando={isLoading}
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
          <Snackbar
            open={openalert}
            autoHideDuration={1200}
            onClose={handleCloseAlert}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert
              onClose={handleCloseAlert}
              severity="error"
              variant="filled"
              sx={{ width: '100%' }}
            >
              {msg}
            </Alert>
          </Snackbar>
          <Grid container direction="column" padding={1} spacing={2}>
            {isLoading && (
              <Grid item>
                <LinearProgress variant='indeterminate' />
              </Grid>
            )}
            <Grid container item direction="row" spacing={1}>
              <Grid container item direction="row" spacing={1} >
                <Grid item xs={12} sm={12} md={4} lg={6} xl={6}>
                  <VTextFieldCpfCnpj
                    fullWidth
                    size='small'
                    name='cpf'
                    disabled={isLoading}
                    label='CPF / CNPJ'
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={6} xl={6}>
                  <VTextField
                    size='small'
                    fullWidth
                    name='nome'
                    label='Nome'
                  />
                </Grid>
              </Grid>
              <Grid container item direction="row" spacing={1} >
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <VTextField
                    size='small'
                    fullWidth
                    name='fantasia'
                    label='Fantasia'
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
                  <VTextField
                    fullWidth
                    size='small'
                    name='rg'
                    disabled={isLoading}
                    label='Insc Est / RG'
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                  <VTextField
                    fullWidth
                    size='small'
                    name='telefone'
                    label='Telefone'
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                  <VTextField
                    fullWidth
                    size='small'
                    name='celular'
                    label='Celular'
                  />
                </Grid>
              </Grid>
              <Grid container item direction="row" spacing={1} >
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <VTextField
                    fullWidth
                    size='small'
                    name='endereco'
                    label='Endereço'

                  />
                </Grid>
                <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
                  <VTextField
                    fullWidth
                    size='small'
                    name='numero'
                    disabled={isLoading}
                    label='Numero'
                  />
                </Grid>
                <Grid item xs={12} sm={10} md={6} lg={6} xl={6}>
                  <VTextField
                    fullWidth
                    size='small'
                    name='bairro'
                    label='Bairro'

                  />
                </Grid>
              </Grid>

              <Grid container item direction="row" spacing={1} >
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <VTextField
                    fullWidth
                    size='small'
                    name='municipio'
                    label='Municipio'

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
                  <VTextField
                    fullWidth
                    size='small'
                    name='cep'
                    disabled={isLoading}
                    label='CEP'
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <VTextField
                    fullWidth
                    size='small'
                    name='email'
                    label='e-mail'

                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TableContainer component={Paper} variant="outlined" sx={{ width: '100%', height: 350, maxHeight: 350 }}>
                <Table size="small">
                  <TableHead sx={{ backgroundColor: '#4484CE' }}>
                    <TableRow
                      sx={{
                        '& th': {
                          backgroundColor: theme =>
                            theme.palette.mode === 'light'
                              ? '#eff6ff'   
                              : '#334155',   

                          color: theme =>
                            theme.palette.mode === 'dark'
                              ? '#e2e8f0'    
                              : '#475569',  

                          fontSize: '0.75rem',
                          fontWeight: 600,
                          textTransform: 'uppercase',
                          letterSpacing: '0.04em',

                          borderBottom: '2px solid',
                          borderColor: theme =>
                            theme.palette.mode === 'light'
                              ? '#bfdbfe'
                              : '#475569',

                          py: 1.5,
                          px: 2,

                          '&:first-of-type': {
                            borderTopLeftRadius: '8px',
                            borderLeft: '1px solid',
                            borderLeftColor: theme =>
                              theme.palette.mode === 'light'
                                ? '#bfdbfe'
                                : '#475569',
                          },

                          '&:last-of-type': {
                            borderTopRightRadius: '8px',
                            borderRight: '1px solid',
                            borderRightColor: theme =>
                              theme.palette.mode === 'light'
                                ? '#bfdbfe'
                                : '#475569',
                          },
                        },
                      }}
                    >
                      <TableCell align='left' sx={{ color: '#fff', flex: 0 }}>Fábrica</TableCell>
                      <TableCell align='right' sx={{ color: '#fff', flex: 1 }}>Percentual</TableCell>
                      <TableCell align='center' sx={{ color: '#fff', flex: 1 }}>Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map(row => (
                      <TableRow key={row.idclifab}
                        hover
                        sx={{ cursor: 'pointer' }}
                      >
                        <TableCell align='left'>{row.nome}</TableCell>
                        <TableCell align='right'>{row.percentual.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
                        <TableCell align='center'>
                          <IconButton size="small" onClick={() => { setIditens(row.idclifab); handleBuscarDados(row.idclifab); setOpen(true); }}>
                            <Icon>edit</Icon>
                          </IconButton>
                        </TableCell>

                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    {isLoading && (
                      <TableRow>
                        <TableCell colSpan={3}>
                          <LinearProgress variant='indeterminate' />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableFooter>
                </Table>
              </TableContainer>
            </Grid>
            <DialogItens
              id={iditens}
              value={PercentualDaFabricaSelecionada.toString()}
              open={open}
              dados={dadositens}
              onDados={handleItens}
              onClose={handleClose}
              nome={nomeDaFabricaSelecionada}
            />
          </Grid>
        </Box>
      </VForm>
    </LayoutBaseDePagina>
  );
};